<template>
  <a-layout class="index animated fadeIn">
    <div class="s_bf">
      <a-form
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item ref="level" label="资质名称" name="level">
          <div class="s_flex_ali">
            <p class="s_c333 mr15">企业营业执照</p>
            <div class="s_flex_ali">
              <WarningOutlined v-if="status !== 1" class="s_cd41" />
              <CheckOutlined v-else class="s_c376" />
              <p>{{ status_text }}</p>
            </div>
          </div>
        </a-form-item>
        <a-form-item
          ref="business_name"
          label="企业名称"
          name="business_name"
          :rules="[
            {
              required: true,
              message: '请输入企业名称'
            }
          ]"
        >
          <a-input
            :disabled="formType != 'edit'"
            v-model:value="form.business_name"
            placeholder="请输入企业名称"
          />
        </a-form-item>
        <a-form-item
          ref="license_no"
          label="营业执照号码"
          name="license_no"
          :rules="[
            {
              required: true,
              message: '请输入营业执照号码'
            }
          ]"
        >
          <a-input-group compact>
            <a-select
              :disabled="formType != 'edit'"
              style="width: 15%"
              v-model:value="form.license_type"
            >
              <a-select-option value="1">中国</a-select-option>
              <a-select-option value="2">国外</a-select-option>
            </a-select>
            <a-input
              :disabled="formType != 'edit'"
              style="width: 85%"
              v-model:value="form.license_no"
              placeholder="营业执照号码"
            />
          </a-input-group>
        </a-form-item>
        <a-form-item ref="bar_code" label="组织机构代码" name="bar_code">
          <a-input
            :disabled="formType != 'edit'"
            v-model:value="form.bar_code"
            placeholder="请输入组织机构代码"
          />
        </a-form-item>
        <a-form-item
          ref="license_images"
          label="营业执照"
          name="license_images"
          :rules="[
            {
              required: true,
              message: '请上传营业执照'
            }
          ]"
        >
          <div class="flex">
            <div class="flex overflow-hidden">
              <a-image-preview-group
                class="overflow-hidden"
                v-if="form.license_images"
              >
                <a-image
                  class="overflow-hidden"
                  :width="100"
                  :height="100"
                  :src="info.picdomain + form.license_images"
                />
              </a-image-preview-group>
            </div>
            <div class="w-100 h-100 relative ml-10" v-if="formType == 'edit'">
              <div
                class="w-0100 h-0100 flex items-center justify-center border-1 border-dashed "
                style="border-color: #ddd;"
              >
                <PlusOutlined />
              </div>
              <uploadImage
                @success="uploadOnSuccess"
                class="opacity-0 absolute left-0 top-0 w-0100 h-0100 z-1"
              ></uploadImage>
            </div>
          </div>
        </a-form-item>
        <a-form-item
          ref="business_addr"
          label="企业地址"
          name="business_addr"
          :rules="[
            {
              required: true,
              message: '请输入企业地址'
            }
          ]"
        >
          <a-input
            :disabled="formType != 'edit'"
            v-model:value="form.business_addr"
            placeholder="请输入企业地址"
          />
        </a-form-item>
        <a-row v-if="formType == 'edit'">
          <a-col :offset="labelCol.span">
            <a-button type="primary" @click="onSubmit">保存</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </a-layout>
</template>
<script>
import {
  WarningOutlined,
  CheckOutlined,
  PlusOutlined
} from "@ant-design/icons-vue";
import { ref, onMounted, reactive, toRefs, inject, watchEffect } from "vue";
import { message } from "ant-design-vue";
import uploadImage from "@/components/image/uploadImage.vue";
import store from "@/store";
// 初始化默认筛选项数值
let defForm = {
  license_type: "1",
  business_name: "",
  business_addr: "",
  license_no: "",
  license_images: "",
  bar_code: ""
};
export default {
  name: "licence",
  components: { WarningOutlined, CheckOutlined, PlusOutlined, uploadImage },
  props: {
    formData: {
      type: Object
    },
    // 类型，add新增、edit修改、detail查看
    formType: {
      type: String,
      default: "detail"
    }
  },
  setup(props, { emit }) {
    //pass
    const form = ref({ ...defForm });
    const state = reactive({
      info: store.state.user.info,
      status: 0,
      status_text: "未认证",
      labelCol: { span: 4 },
      wrapperCol: { span: 20 }
    });
    const ruleForm = ref();
    const _lodash = inject("_lodash");
    const onSubmit = () => {
      ruleForm.value
        .validate()
        .then(() => {
          emit("onsubmit", form.value);
        })
        .catch((error) => {
          console.log("error", error);
        });
    };
    onMounted(() => {
    });

    watchEffect(() => {
      var formData = props.formData || {};

      if (!_lodash.isEmpty(formData.content)) {
        form.value = formData.content;
        state.status = formData.status;
        state.status_text = formData.status_text;
      } else {
        form.value = defForm;
        state.status = formData.status;
        state.status_text = formData.status_text;
      }
    });
    // 图片上传
    const uploadOnSuccess = (data) => {
      form.value.license_images = data.path;
    };
    return {
      form,
      ...toRefs(state),
      ruleForm,
      onSubmit,
      uploadOnSuccess
    };
  }
};
</script>
<style></style>
